import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M9.592 22.736q-.146-.187 0-3.337-1.553.054-1.964-.215c-.41-.27-.82-1.1-1.183-1.686s-1.172-.678-1.498-.809c-.326-.13-.408-.664.899-.26 1.306.403 1.37 1.502 1.782 1.759s1.398.144 1.844-.062.414-.972.494-1.275c.1-.284-.254-.347-.262-.349-.436 0-2.727-.498-3.356-2.716-.63-2.219.181-3.669.613-4.292q.433-.623-.076-2.657Q8.733 6.601 9.737 8c0 .006.877-.521 2.263-.521s1.878.429 2.257.521.683-1.633 3.026-1.163c-.489.962-.899 2.163-.586 2.657s1.54 2.064.786 4.292q-.753 2.227-2.964 2.716-.253.081-.253.261c0 .18.228.2.557 1.043q.33.843.048 4.818-.714.18-1.11.244c-.469.073-.978.115-1.478.13-.5.016-.673.015-1.364-.05a10 10 0 0 1-1.327-.212",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }